import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getOrganizers } from '../../../api/services/Organizers';
import { Organizer } from '../../types';

export const useOrganizers = () => {
  const [organizers, setOrganizers] = useState<Organizer[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get('search');
  const showDeactivated = searchParams.get('showDeactivated');

  const fetchOrganizers = async (params: {
    perPage: number;
    page: number;
    q: string | null;
    deactivated: Nullable<boolean>;
  }) => {
    const abortController = new AbortController();

    setIsFetching(true);
    const response = await getOrganizers({ ...params, withoutRoles: ['onsite_staff'] }, abortController.signal);

    if (response.type === 'success' && !abortController.signal.aborted) {
      if (params.page === 1) {
        setOrganizers(response.data.organizers);
      } else {
        setOrganizers([...organizers, ...response.data.organizers]);
      }
    }
    setIsFetching(false);
  };

  return {
    organizers,
    urlSearchParams: {
      searchValue,
      showDeactivated,
    },
    isFetching,
    fetchOrganizers,
  };
};
